import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { announcementsTranslationRef } from '@internal/plugin-announcements/src/components/translation';

export const announcementsTranslations = createTranslationResource({
  ref: announcementsTranslationRef,
  translations: {
    en: () => import('./announcements-en'),
    es: () => import('./announcements-es'),
  },
});